export const module = {
  info: {
    name: 'subscription-plans',
    caption: 'subscription plans',
    viewGroup: 'mrt-modules'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  // noRoutes: true,
  sideMenu: {
    topSeparator: false,
    caption: 'subscription plans',
    icon: 'el-icon-folder',
    routeName: 'module->subscription-plans->list->page',
    routeParams: { listPage: 1}
  }
}

export default module
